import {Component, EventEmitter, OnDestroy, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {CellComponent} from '@shared/components/cell-components/cell-component';
import {FieldDefinition} from '@shared/models/field-definition';
import {Store} from '@ngrx/store';
import {InboxState} from '../../../store/reducers/inbox.reducers';
import {ActivatedRoute, Router} from '@angular/router';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';

@Component({
    standalone: false,
    selector: 'particle-platform-mail-cell-viewer',
  templateUrl: './platform-mail-cell-viewer.component.html',
  styleUrls: ['./platform-mail-cell-viewer.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PlatformMailCellViewerComponent implements OnInit, CellComponent, OnDestroy {
  invalidateSubject?: InvalidateSubject;
  item: any;
  fieldDefinition: FieldDefinition;
  sourceType: string;
  mail: any;
  disabled: boolean;
  @Output() valueChanged: EventEmitter<any> = new EventEmitter();
  selected: boolean;
  constructor(private store: Store<InboxState>,
              protected route: Router,
              protected activatedRoute: ActivatedRoute) {
  }

  ngOnInit() {

  }

  refresh() {

  }

  onSelectedChange() {

  }

  detailMail() {
    this.valueChanged.emit({item: this.item, action: {id: 'Open' }});
  }
  ngOnDestroy() {
  }
}
